import {RefObject} from 'react';
import {CircleCheck, ArrowLeft} from 'lucide-react';
import {cn, WebcamRefTypes} from '@chekin/guestapp-ui-kit';
import styles from './stylesMobile.module.css';
import {StyledWebcam} from './styled';
import {useTranslation} from 'react-i18next';
import {useErrorModal} from '@chekin/shared';

interface IVQRScannerMobileViewProps {
  webcamRef: RefObject<WebcamRefTypes>;
  showSuccessIcon: boolean;
  handleUserMedia: () => void;
  handleBack: () => void;
}

function IVQRScannerMobileView({
  webcamRef,
  showSuccessIcon,
  handleUserMedia,
  handleBack,
}: IVQRScannerMobileViewProps) {
  const {t} = useTranslation('identity-verification');
  const {displayError, ErrorModal} = useErrorModal();

  return (
    <div className={styles.container}>
      <StyledWebcam
        ref={webcamRef}
        onUserMedia={handleUserMedia}
        videoConstraints={{
          facingMode: 'environment',
        }}
        onError={displayError}
      >
        <div className={styles.header}>
          <button className={styles.backButton} onClick={handleBack} aria-label="Go back">
            <ArrowLeft size={24} className={styles.backIcon} />
          </button>
          <h1 className={styles.title}>{t('scan_qr_code')}</h1>
          <div className={styles.spacer} />
        </div>

        <p className={styles.subtitle}>{t('position_qr_code_inside_frame')}</p>

        <div
          className={cn(styles.successIcon, showSuccessIcon && styles.successIcon__show)}
        >
          <CircleCheck size={72} color="#20C997" />
        </div>
      </StyledWebcam>
      <ErrorModal />
    </div>
  );
}

export {IVQRScannerMobileView};
